import {
  ActionContributionsService,
  AndromedaMenuItem,
} from '@ansys-internal/awf-angular/contributions';
import { Icons, IconType } from '@ansys-internal/awc-angular/icons';
import { State } from '@ansys-internal/awf-angular/store';
import {
  DialogService,
  SnackBarService,
  TableRefreshDataAction,
} from '@ansys-internal/awf-angular/shared';
import { lastValueFrom } from 'rxjs';
import { AWFExecute, AWFMenuItem } from '@ansys-internal/awf-angular/core';
import { ContributionsEnum } from '../../../contributions.enum';
import { DriveCyclesService } from '../../../../../api';
import { ActiveConceptState } from '../../../../state/lib/active-concept.state';
import { AlertComponent } from '../../../../components/dialogs/alert/alert.component';
import { ConfirmComponent } from '../../../../components/dialogs/confirm/confirm.component';
import { LoadingComponent } from '../../../../components/dialogs/loading/loading.component';

@AWFMenuItem({
  id: ContributionsEnum.DRIVE_CYCLE_MENU_ITEM_DELETE_ID,
  priority: 50,
})
export class DriveCycleTableDeleteMenuItem implements AWFExecute<any> {
  id: string = ContributionsEnum.DRIVE_CYCLE_MENU_ITEM_DELETE_ID;
  priority: number = 50;
  type: string = ContributionsEnum.DRIVE_CYCLE_MENU_ITEM_DELETE_ID;
  prefixIcon: IconType = { icon: Icons.DELETE };
  showOnHover: boolean = false;
  text: string = 'Delete Item';

  constructor(
    private state: State,
    private driveCycleService: DriveCyclesService,
    private snackbar: SnackBarService,
    private action: ActionContributionsService,
    private dialogService: DialogService
  ) {}

  async execute(context: any): Promise<void> {
    const concept = this.state.value(ActiveConceptState);
    if (!concept) return;
    const driveCycleId = context.id;

    if (context.selected) {
      this.dialogService.open(AlertComponent, {
        title: 'Cannot delete selected drive cycle',
        data: {
          message: 'Please select another drive cycle to delete.',
        },
      });
    } else {
      const dialog = this.dialogService.open(ConfirmComponent, {
        title: 'Are you sure you want to delete this Drive Cycle?',
        data: {
          onConfirm: async () => {
            dialog.close();
            const loadingDialog = this.dialogService.open(LoadingComponent);
            lastValueFrom(
              this.driveCycleService.deleteDriveCyclesItemIdDelete(
                driveCycleId,
                concept.design_instance_id
              )
            )
              .then(() => {
                this.snackbar.success('Drive Cycle Deleted');
                this.action.execute(
                  TableRefreshDataAction,
                  ContributionsEnum.DRIVE_CYCLE_TABLE_ID
                );

                loadingDialog.close();
              })
              .catch(() => {
                this.snackbar.error('Failed to delete Drive Cycle');
              });
          },
          onCancel: () => {
            dialog.close();
          },
        },
      });
    }
  }

  render(): AndromedaMenuItem {
    return this;
  }
}
